export enum ReviewProvider {
  TRUSTPILOT = 'trustpilot',
  GOOGLE = 'google',
}
